// extracted by mini-css-extract-plugin
export default {"tabs":"style_tabs__HLOda","tab":"style_tab__8z-3g","tabSelected":"style_tabSelected__8nJky","tabDisabled":"style_tabDisabled__rnUll"};